<template>
	<v-form @submit.prevent="submitForm" ref="formRef" class="d-flex flex-column ga-3 ga-sm-5">
		<!-- Remove lazy-validation -->

		<ErrorMessage :errorMessage="state.errorMessage" />



		<CustomInput label="Email" placeholder="Type your Email" v-model="state.email"
			:error-messages="v$.email.$errors.map((e: any) => e.$message)" @blur="v$.email.$touch()" />


		<CustomInput label="Password" placeholder="Type your password" type="password" v-model="state.password"
			:error-messages="v$.password.$errors.map((e: any) => e.$message)" @blur="v$.password.$touch()" />


		<div class="d-flex justify-center pointer text-primary text-15 weight-500" @click="forgotPasswordClicked">
			Forgot Password?
		</div>



		<button type="submit" :loading="isSubmitting" :disabled="isSubmitting" class="button-auth--email rounded-pill">
			<span class="button-auth__text"> {{ isSubmitting ? 'Signing in...' : 'Sign in' }} </span>
		</button>




	</v-form>
</template>



<script setup lang="ts">

import { reactive, ref } from 'vue';
import authEvents from '@/Events/AuthDialog';
import { useAuthStore } from '@/store/AuthStore';
import { useVuelidate } from '@vuelidate/core';
import { signinRules } from '@/utils/ValidationRules';
import forgotPasswordEvents from '@/Events/ForgotPassword';
import CustomInput from '@/components/Common/CustomInput.vue';
import ErrorMessage from '@/components/Auth/Common/Messeges/ErrorMessage.vue';

const state = reactive({
	email: '',
	password: '',
	errorMessage: '',
});

const v$ = useVuelidate(signinRules, state);
const isSubmitting = ref(false);
const authStore = useAuthStore();





const submitForm = async () => {
	v$.value.$touch();
	if (v$.value.$invalid) {
		state.errorMessage = 'Please fill in all required fields correctly.';
		return;
	}

	isSubmitting.value = true;
	state.errorMessage = '';

	try {
		await authStore.loginWithEmail(state.email, state.password);
	} catch (error: any) {
		state.errorMessage = error.friendly_message || 'An error occurred during sign in.';
	} finally {
		isSubmitting.value = false;
	}
};





const forgotPasswordClicked = () => {
	forgotPasswordEvents.emit('forgot-password-clicked');
	authEvents.emit('close-auth-dialog')
};


</script>
